import isRequired from './isRequired';

function decodeId(encodedId = isRequired('encodedId', 'decodeId')) {
  const typedId = atob(encodedId);
  const id = typedId && typedId.split(':')[1];
  return parseInt(id, 10);
}

export default decodeId;
